// @flow

import styled from 'styled-components';

export const FieldsHolder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
  padding: 16px;
  &:empty {
    display: none;
  }
`;
